import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'
import { de } from '@braid/vue-formulate-i18n'
import App from './App.vue'
import MyLabel from './MyLabel.vue'

Vue.component('MyLabel', MyLabel)
Vue.config.productionTip = false
Vue.use(VueFormulate,  {
  plugins: [ de ],
  locale: 'de',
  slotComponents: {
    label: 'MyLabel'
  }
})

new Vue({
  render: h => h(App),
}).$mount('#vhw_contact_form')
